import { useGetAvailableSyncTasksQuery } from "state/rtkQuery/sync/syncQueries";

import { taskOutcome } from "./syncFormat";

// The task catalogue says how each task finishes: "dispatcher_only" tasks hand work to others and finish before it is
// done; "task_execution_only" tasks do their work themselves. A dispatcher's SUCCESS is shown as "Dispatched".
export const useCompletionSemantics = () => {
  const { data } = useGetAvailableSyncTasksQuery();
  return Object.fromEntries((data?.task_catalogue || []).map((entry) => [entry.task, entry.completion_semantics]));
};

// The outcome of a live or stored task, with the catalogue's completion semantics applied when it knows the task.
export const useTaskOutcome = (task) => {
  const semantics = useCompletionSemantics();
  const name = task?.taskName || task?.task_name;
  return taskOutcome({ ...task, completion: task?.completion ?? semantics[name] });
};
